import { H4, Body2 } from '../themes/typography';
import '../styles/animation/AuthVerification.css';

const AuthVerification = ({
    message = 'Please wait...',
    subMessage = 'We are verifying your authentication status'
}) => {
    return (
        <div className="auth-loader3-overlay">
            <div className="auth-loader3-container">
                <div className="auth-minimal-content">
                    {/* Simple Icon */}
                    <div className="auth-icon-container">
                        <svg
                            className="auth-lock-icon"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                            <circle cx="12" cy="16" r="1"></circle>
                            <path d="M7 11V7a5 5 0 0110 0v4"></path>
                        </svg>
                    </div>

                    {/* Text Content */}
                    <div className="auth-text-content">
                        <H4 fontWeight={700}>{message}</H4>
                        <Body2 color="var(--gray-secondary-color)">{subMessage}</Body2>
                    </div>

                    {/* Animated Dots */}
                    <div className="auth-dots-container">
                        <div className="auth-dot auth-dot-1"></div>
                        <div className="auth-dot auth-dot-2"></div>
                        <div className="auth-dot auth-dot-3"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthVerification;
